import createReducer from '../lib/createReducer';
import * as types from '../actions/types';

export const Formresponse = createReducer(
  {
    formresponse: [],
    campaignType: '',
    getServiceList: false,
    campaigns: {},
    webhook: {},
    updateWebhook: false,
  },
  {
    [types.GET_FORMRESPONSE_START](state) {
      const newState = Object.assign({}, state, {
        getFormSummary: true,
      });

      return newState;
    },
    [types.GET_FORMRESPONSE_FAIL](state) {
      const newState = Object.assign({}, state, {
        getFormSummary: false,
      });

      return newState;
    },
    [types.GET_FORMRESPONSE_SUCCESS](state, actions) {
      console.log('state', actions);
      const newState = Object.assign({}, state, {
        getFormSummary: false,
        formresponse: actions.formresponse,
      });
      return newState;
    },
    [types.GET_CAMPAIGNDATA_START](state) {
      const newState = Object.assign({}, state, {
        getFormSummary: true,
      });

      return newState;
    },
    [types.GET_CAMPAIGNDATA_FAIL](state) {
      const newState = Object.assign({}, state, {
        getFormSummary: false,
      });

      return newState;
    },
    [types.GET_CAMPAIGNDATA_SUCCESS](state, actions) {
      console.log('GET_CAMPAIGNDATA_SUCCESS', actions);
      const newState = Object.assign({}, state, {
        getFormSummary: false,
        campaigns: actions.campaignData,
      });
      return newState;
    },
    [types.GET_LETRENDS_START](state) {
      const newState = Object.assign({}, state, {
        getFormSummary: true,
      });

      return newState;
    },
    [types.GET_LETRENDS_FAIL](state) {
      const newState = Object.assign({}, state, {
        getFormSummary: false,
      });

      return newState;
    },
    [types.GET_LETRENDS_SUCCESS](state, actions) {
      console.log('GET_CAMPAIGNDATA_SUCCESS', actions);
      const newState = Object.assign({}, state, {
        getFormSummary: false,
        trends: actions.trends,
      });
      return newState;
    },
    [types.GET_FORMLIST_SUCCESS](state, actions) {
      console.log('state', actions);
      const newState = Object.assign({}, state, {
        gotFormlist: true,
        formrlist: actions.campaignlist,
      });
      return newState;
    },
    [types.GET_CAMPAIGN_LIST_SUCCESS](state, actions) {
      console.log('state', actions);
      const newState = Object.assign({}, state, {
        gotCampaginlist: true,
        campaignlist: actions.campaignlist,
      });
      return newState;
    },
    [types.GET_FORMSERVICES_SUCCESS](state, actions) {
      console.log('state', actions);
      const newState = Object.assign({}, state, {
        gotServicelist: true,
        getServiceList: false,
        servicelist: actions.servicelist,
        campaignType: actions.campaignType,
      });
      return newState;
    },
    [types.GET_FORMSERVICES_START](state, actions) {
      const newState = Object.assign({}, state, {
        gotServicelist: false,
        getServiceList: true,
      });
      return newState;
    },
    [types.GET_FORMSERVICES_FAIL](state, actions) {
      const newState = Object.assign({}, state, {
        gotServicelist: false,
        getServiceList: false,
      });
      return newState;
    },
    [types.SET_CAMPAIGNTYPE_SUCCESS](state, actions) {
      console.log(actions.campaignType);
      const newState = Object.assign({}, state, {
        campaignType: actions.campaignType,
      });
      return newState;
    },
    [types.POST_FORM_START](state) {
      const newState = Object.assign({}, state, {
        postForm: true,
      });
      return newState;
    },
    [types.POST_FORM_FAIL](state) {
      const newState = Object.assign({}, state, {
        postForm: false,
        postFail: true,
      });
      return newState;
    },
    [types.POST_FORM_SUCCESS](state, actions) {
      let originalForms = { ...state.campaigns };
      let filterd = originalForms.campaigns.filter((campaign) => {
        return campaign.id !== actions.form.id;
      });
      filterd.push(actions.form);
      originalForms.campaigns = filterd;
      const newState = Object.assign({}, state, {
        postForm: false,
        postFail: false,
        form: actions.form,
        campaigns: originalForms,
      });
      return newState;
    },
    [types.EDIT_FORM_SUCCESS](state, actions) {
      let originalForms = { ...state.campaigns };
      let filterd = originalForms.campaigns.filter((campaign) => {
        return campaign.id !== actions.form.id;
      });
      filterd.push(actions.form);
      originalForms.campaigns = filterd;
      const newState = Object.assign({}, state, {
        postForm: false,
        postFail: false,
        editSucces: true,
        form: actions.form,
        campaigns: originalForms,
      });
      return newState;
    },
    [types.FORM_CLEAR_FLAGS](state) {
      const newState = Object.assign({}, state, {
        postForm: undefined,
        postFail: undefined,
        form: undefined,
        deleteSuccess: undefined,
        editSucces: undefined,
        details: undefined,
      });
      return newState;
    },
    [types.POST_DETAILS_START](state) {
      const newState = Object.assign({}, state, {
        postDetails: true,
      });
      return newState;
    },
    [types.POST_DETAILS_SUCCESS](state, action) {
      const newState = Object.assign({}, state, {
        postDetails: false,
        details: action.details,
        postDetailFail: false,
      });
      return newState;
    },
    [types.POST_DETAILS_FAIL](state, action) {
      const newState = Object.assign({}, state, {
        postDetails: false,
        postDetailFail: true,
      });
      return newState;
    },
    [types.DELETE_FORM_SUCCESS](state, action) {
      let originalForms = { ...state.campaigns };
      let filterd = originalForms.campaigns.filter((campaign) => {
        return campaign.id !== action.details.id;
      });
      originalForms.campaigns = filterd;
      const newState = Object.assign({}, state, {
        postForm: false,
        postFail: false,
        deleteSuccess: true,
        campaigns: originalForms,
      });
      return newState;
    },
    [types.SAVE_LEAD_NAME](state, action) {
      const newState = Object.assign({}, state, {
        leadName: action.name,
      });
      return newState;
    },
    [types.GET_LEAD_REPORT_START](state) {
      const newState = Object.assign({}, state, {
        gettingLeadReport: true,
      });
      return newState;
    },
    [types.GET_LEAD_REPORT_FAIL](state) {
      const newState = Object.assign({}, state, {
        gettingLeadReport: false,
        reportSucess: false,
      });
      return newState;
    },
    [types.GET_LEAD_REPORT_SUCCESS](state, action) {
      const newState = Object.assign({}, state, {
        gettingLeadReport: false,
        reportSucess: true,
        report: action.report,
      });
      return newState;
    },
    [types.GET_NOTIFICATIONWEBHOOKS_SUCCESS](state, action) {
      const newState = Object.assign({}, state, {
        webhook: action.webhook,
      });
      return newState;
    },
    [types.UPDATE_NOTIFICATIONWEBHOOKS_START](state) {
      const newState = Object.assign({}, state, {
        updateWebhook: true,
        successfulwebhook: false,
      });
      return newState;
    },
    [types.UPDATE_NOTIFICATIONWEBHOOKS_FAIL](state) {
      const newState = Object.assign({}, state, {
        updateWebhook: false,
        successfulwebhook: false,
      });
      return newState;
    },
    [types.UPDATE_NOTIFICATIONWEBHOOKS_SUCCESS](state, action) {
      let originalwebhook = { ...state.webhook };
      originalwebhook.webhook_url = action.webhook;
      const newState = Object.assign({}, state, {
        updateWebhook: false,
        webhook: originalwebhook,
        successfulwebhook: true,
      });
      return newState;
    },
    [types.DELETE_NOTIFICATIONWEBHOOKS_START](state) {
      const newState = Object.assign({}, state, {
        deleteWebhook: true,
      });
      return newState;
    },
    [types.DELETE_NOTIFICATIONWEBHOOKS_FAIL](state) {
      const newState = Object.assign({}, state, {
        deleteWebhook: false,
      });
      return newState;
    },
    [types.DELETE_NOTIFICATIONWEBHOOKS_SUCCESS](state) {
      let originalwebhook = { ...state.webhook };
      originalwebhook.webhook_url = '';
      const newState = Object.assign({}, state, {
        deleteWebhook: false,
        webhook: originalwebhook,
      });
      return newState;
    },
  },
);

export { Formresponse as default };
